const PIXEL_IDS = ['1030168916848827', '1342272467727965']

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

let initialized = false

function ensurePixel() {
  if (initialized) return
  initialized = true

  const f = window
  const b = document

  if (f.fbq) return

  const n: any = (f.fbq = function (...args: unknown[]) {
    if (n.callMethod) {
      n.callMethod.apply(n, args)
    } else {
      n.queue.push(args)
    }
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = [] as unknown[][]

  const t = b.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const s = b.getElementsByTagName('script')[0]
  s?.parentNode?.insertBefore(t, s)

  PIXEL_IDS.forEach((id) => window.fbq('init', id))
}

function generateEventId(): string {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`
}

export function trackPageView() {
  ensurePixel()
  const eventID = generateEventId()
  console.log('[MetaPixel] PageView', { eventID })
  window.fbq('track', 'PageView', {}, { eventID })
}

export function trackLead(
  buttonName: string,
  destination: string,
): Promise<void> {
  ensurePixel()
  const eventID = generateEventId()
  console.log('[MetaPixel] Lead', { button: buttonName, eventID, destination })
  window.fbq(
    'track',
    'Lead',
    {
      content_name: 'Código Spanglish',
      button_name: buttonName,
      destination,
    },
    { eventID },
  )

  return new Promise((resolve) => setTimeout(resolve, 300))
}

export function trackAddToCart(
  buttonName: string,
  destination: string,
): Promise<void> {
  ensurePixel()
  const eventID = generateEventId()
  console.log('[MetaPixel] AddToCart', {
    button: buttonName,
    eventID,
    destination,
  })
  window.fbq(
    'track',
    'AddToCart',
    {
      content_name: 'Código Spanglish',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
      button_name: buttonName,
      destination,
    },
    { eventID },
  )

  return new Promise((resolve) => setTimeout(resolve, 300))
}
